<template>
    <div v-if="isLoaded">
        <b-card v-if="this.gbId(this.$store.state.user.customerId) && this.route.params.form_type == 1">
            <div style="font-weight: bold; margin-top: 0px">{{ $t(name) }}</div>
            <custom-form
                :isEditable="true"
                :schema="formSchema"
                :data="formData"
                @formChange="onformChange"
                style="margin-top: 30px"/>
            <custom-form-table
                :isEditable="true"
                :initialData="{items: tableData, fields: tableCols}"
                @applyDataChanges="applyDataChanges"
                @insertItem="insertItem"
                @deleteItemById="deleteItemById"
                style="margin-top: 60px; margin-bottom: 60px"/>
            <div class="d-flex justify-content-end">
                <div class="p-2">
                <p class="font-weight-bold">{{$t('saveForm')}}</p>
                <b-btn @click="createForm()" class="btn-success" :disabled="disabled" >{{$t('create')}}</b-btn>
                </div>
            </div>
        </b-card>
        <b-card v-else>
            <div style="font-weight: bold; margin-top: 0px">{{ $t(name) }}</div>
            <custom-form
                :isEditable="true"
                :schema="formSchema"
                :data="formData"
                @formChange="onformChange"
                style="margin-top: 30px"/>
            <custom-table
                :isEditable="true"
                :initialData="{items: tableData, fields: tableCols}"
                @applyDataChanges="applyDataChanges"
                @insertItem="insertItem"
                @deleteItemById="deleteItemById"
                style="margin-top: 60px; margin-bottom: 60px"/>
            <div class="d-flex justify-content-end">
                <div class="p-2">
                <p class="font-weight-bold">{{$t('saveForm')}}</p>
                <b-btn @click="createForm()" class="btn-success" :disabled="disabled" >{{$t('create')}}</b-btn>
                </div>
            </div>
        </b-card>
    </div>
    <div v-else></div>
</template>

<script>
import uuidV4 from 'uuid/v4';
import moment from 'moment';
import _ from 'lodash';

import CustomForm from '../../../components/CustomForm';
import CustomTable from '../../../components/CustomTable';
import CustomFormTable from '../../../components/CustomFormTable';

export default {
    name: 'FormCreate',
    data() {
        return {
            isLoaded: false,
            formSchema: [],
            tableCols: [],
            tableData: [],
            emptyFields: [],
            formData: {},
            name: null,
            disabled: false
        };
    },
    components: {
        CustomTable,
        CustomForm,
        CustomFormTable
    },
    methods: {
        onformChange(formData) {
            this.formData = formData;
        },
        findEmptyFields(data, schema) {
            let emptyFields = [];
            for (let key in data) {
                let foundCol = _.find(schema, {key: key});
                if (
                    (data[key] === null ||
                        data[key] === undefined ||
                        (typeof data[key] === 'string' && !data[key].length)) &&
                    foundCol.editable
                ) {
                    emptyFields.push(key);
                }
            }
            return emptyFields;
        },
        createForm() {
            this.disabled = true;
            this.$toasted.show(this.$t('formCreateMsg'));
            function compareDate(lst) {
                let greatest = true;
                let [compel] = lst.splice(-1, 1);
                lst.forEach(el => {
                    if (el.typeId === compel.typeId && el.date >= compel.date) {
                        greatest = false;
                    }
                });
                return !greatest;
            }
            this.emptyFields = this.findEmptyFields(this.formData, this.formSchema);
            this.formData.date = moment().toDate();
            //if(this.route.params.form_type == 2) {this.formData.date = moment()};
            if (!this.emptyFields.length && !_.isEmpty(this.tableData)) {
                if (
                    this.tableData[0].wasteType &&
                    compareDate(
                        _.map(this.tableData, data => {
                            if (typeof data.deliveryDate === 'string') {
                                data.deliveryDate = new Date(data.deliveryDate);
                            }
                            if (data.deliveryDate) {
                                data.deliveryDate = this.createUTCDate(
                                    data.deliveryDate.getFullYear(),
                                    data.deliveryDate.getMonth(),
                                    data.deliveryDate.getDate()
                                );
                            }
                            return {typeId: data.wasteType.id, date: new Date(data.deliveryDate)};
                        })
                    )
                ) {
                    this.$toasted.error(this.$t('date-error'));
                    this.disabled = false;
                    return;
                }
                this.$Progress.start();
                _.each(this.tableData, data => {
                    let keys = Object.keys(_.get(data, 'file') || {});
                    if (keys && keys.length === 3 && keys.includes('editedFileId')) {
                        data.file.fileId = _.get(data, 'file.editedFileId');
                        data.file.fileUrl = _.get(data, 'file.editedFileUrl');
                        data.file.filename = _.get(data, 'file.editedFilename');
                    }
                    if (
                        (!_.get(data, 'file.editedFileId') && _.get(data, 'file.editedFileUrl')) ||
                        (!_.get(data, 'file.fileId') && !_.get(data, 'file.editedFileUrl'))
                    ) {
                        data.file = undefined;
                    }
                });
                return this.axios
                    .post(`/${this.route.params.site_id}/form/${this.route.params.form_type}`, {
                        table: this.tableData,
                        form: this.formData
                    })
                    .then(response => {
                        if (_.get(response, 'status') === 200) {
                            this.$router.push({
                                name: 'site-forms',
                                params: {site_id: this.route.params.site_id}
                            });
                        } else {
                            this.$toasted.error(this.$t('unexpectedError'));
                            this.disabled = false;
                        }
                    })
                    .catch(err => {
                        let message = _.get(err, 'response.data.message');
                        if (message) {
                            this.$toasted.error(this.$t(message));
                        } else {
                            this.$toasted.error(this.$t('unexpectedError'));
                        }
                        this.disabled = false;
                    });
            } else {
                _.isEmpty(this.tableData)
                    ? this.$toasted.error(this.$t('missingTableRow'))
                    : this.$toasted.error(this.$t('missingError'));
                this.disabled = false;
            }
        },
        applyDataChanges(item, fields, callback) {
            let updatedItem = {
                id: item.id
            };
            fields.forEach(field => {
                if (field.editable && item[field.key]) {
                    if (field.type === 'date') {
                        updatedItem[field.key] = moment(item[field.key].editedValue).toDate();
                    } else if (field.type === 'daterange') {
                        updatedItem[field.key] = item[field.key].value;
                    } else if (field.type === 'number' || field.type === 'float') {
                        updatedItem[field.key] = this.delocalizeValue(
                            item[field.key].editedValue,
                            this.locale
                        );
                    } else if (field.type === 'file') {
                        updatedItem[field.key] = item[field.key];
                    } else {
                        updatedItem[field.key] = item[field.key].editedValue;
                    }
                }
            });
            let cloned = [...this.tableData];
            cloned.forEach((element, index) => {
                if (element.id === updatedItem.id) {
                    cloned[index] = updatedItem;
                }
            });
            this.tableData = cloned;
            this.tableData.map(callback);
        },
        insertItem(item, callback) {
            let insertedItem = {};

            this.tableCols.forEach(field => {
                if (field.editable) {
                    if (field.type === 'date') {
                        insertedItem[field.key] = moment(item[field.key].value).toDate();
                    } else if (field.type === 'daterange') {
                        insertedItem[field.key] = _.get(item,`${field.key}.value`);
                    } else if (field.type === 'number' || field.type === 'float') {
                        insertedItem[field.key] = this.delocalizeValue(
                            item[field.key].value,
                            this.locale
                        );
                    } else if (field.type === 'file') {
                        insertedItem[field.key] = item[field.key];
                    } else {
                        insertedItem[field.key] = _.get(item,`${field.key}.value`);
                    }
                }
            });
            insertedItem.id = uuidV4();
            this.tableData.push(insertedItem);
            return callback(insertedItem);
        },
        deleteItemById(id) {
            this.tableData = this.tableData.filter(item => {
                return item.id !== id;
            });
        },
        fetchDesign() {
            return this.axios
                .get(`/form/design/${this.route.params.site_id}/${this.route.params.form_type}`)
                .then(({data}) => {
                    this.formSchema = data.form;
                    this.formData = data.formData;
                    if (this.formData.date) {
                        this.formData.date = this.formData.date.split('T')[0];
                    }
                    this.tableCols = data.table;
                    this.tableData = data.tableData ? data.tableData : [];
                    this.name = data.name;
                    return data;
                });
        },
        init() {
            this.isLoaded = false;
            this.fetchDesign().then(() => {
                this.isLoaded = true;
            });
        }
    },
    created() {
        this.init();
    }
};
</script>

<style scoped>
</style>

<i18n src="../../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "date-error": "Önceki verinin tarihinden eski tarih girilemez!",
            "unexpectedError": "Beklenmeyen bir hata oluştu!",
            "formCreateMsg": "Form oluşturuluyor. Lütfen bekleyin.",
            "saveForm" : "Formu kaydetmek için 'Oluştur' butonuna tıklayın"
        },
        "en": {
            "date-error": "Entering an older date than previous dates is not allowed!",
            "unexpectedError": "An unexpected error ocurred!",
            "formCreateMsg": "Form is being created. Please wait.",
            "saveForm" : "Click the 'Create' button to save the form"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Doc/Forms/FormCreate.vue